import { Link } from 'react-router-dom';
import type { Category } from '@/mocks/articles';

interface CategoryCardProps {
  category: Category;
}

export default function CategoryCard({ category }: CategoryCardProps) {
  return (
    <Link
      to={`/category/${category.slug}`}
      className="group block relative rounded-lg overflow-hidden cursor-pointer h-64"
    >
      <img
        src={category.imageUrl}
        alt={category.name}
        className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110"
      />
      <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
      <div className="absolute bottom-0 left-0 right-0 p-5">
        <h3 className="font-heading text-lg font-semibold text-white mb-1">{category.name}</h3>
        <p className="text-white/70 text-sm line-clamp-1">{category.description}</p>
        <span className="inline-block mt-2 text-xs text-white/60">{category.articleCount} 篇文章</span>
      </div>
    </Link>
  );
}